// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2cbb3ae1","977":"e7e9cf68"}[chunkId] + ".chunk.js";
};